module.exports = __webpack_public_path__ + "img/grid-dots-top.26bd228e.svg";